import { useEphattaQuery } from "../../.."
import { useCustomerService } from "./useCustomerService"

export const useCustomerDetails = (userId: string, suspense: boolean = false) => {
    const service = useCustomerService()
    return useEphattaQuery(["Customer.Details", userId], () => service.details(userId), { suspense })
} 